import type { FC } from 'react';
import { DocuLink, VStack } from 'src/components/BasicComponents';

export const FeibotConfiguration: FC = () => {
  return (
    <VStack>
      <div>
        Read the
        <DocuLink
          path="predictive-tracking-with-data-from-timekeeping/other-timing-sytem#foward-data"
          style={{ margin: '1ch' }}
        />
        to set up Feibot for forwarding reads to Racemap.
      </div>
    </VStack>
  );
};
